// Names match QrWalletEnum displayName. Sources and pending assets: docs/bank-logos.md.
export const bankLogoByName: Readonly<Record<string, string>> = {
  "BANCO DE GALICIA Y BUENOS AIRES S.A.": "/img/banks/007.svg",
  "BANCO DE LA NACION ARGENTINA": "/img/banks/011.svg",
  "BANCO DE LA PROVINCIA DE BUENOS AIRES": "/img/banks/014.svg",
  "INDUSTRIAL AND COMMERCIAL BANK OF CHINA": "/img/banks/015.svg",
  "CITIBANK N.A.": "/img/banks/016.svg",
  "BANCO BBVA ARGENTINA S.A.": "/img/banks/017.svg",
  "BANCO DE LA PROVINCIA DE CORDOBA S.A.": "/img/banks/020.svg",
  "BANCO SUPERVIELLE S.A.": "/img/banks/027.svg",
  "BANCO DE LA CIUDAD DE BUENOS AIRES": "/img/banks/029.svg",
  "BANCO PATAGONIA S.A.": "/img/banks/034.svg",
  "BANCO HIPOTECARIO S.A.": "/img/banks/044.svg",
  "BANCO DE SAN JUAN S.A.": "/img/banks/045.svg",
  "BANCO MUNICIPAL DE ROSARIO": "/img/banks/065.svg",
  "BANCO SANTANDER ARGENTINA S.A.": "/img/banks/072.svg",
  "BANCO DEL CHUBUT S.A.": "/img/banks/083.png",
  "BANCO DE SANTA CRUZ S.A.": "/img/banks/086.svg",
  "BANCO DE LA PAMPA SA": "/img/banks/093.png",
  "BANCO DE CORRIENTES S.A.": "/img/banks/094.svg",
  "BANCO PROVINCIA DEL NEUQUÉN SOCIEDAD ANÓ": "/img/banks/097.svg",
  "BANK OF CHINA LIMITED SUCURSAL BUENOS AI": "/img/banks/131.ico",
  "BRUBANK S.A.U.": "/img/banks/143.svg",
  "BIBANK S.A.": "/img/banks/147.png",
  "JPMORGAN CHASE BANK, NATIONAL ASSOCIATIO": "/img/banks/165.svg",
  "BANCO CREDICOOP COOPERATIVO LIMITADO": "/img/banks/191.svg",
  "BANCO DE VALORES S.A.": "/img/banks/198.svg",
  "BANCO ROELA S.A.": "/img/banks/247.png",
  "BANCO MARIVA S.A.": "/img/banks/254.png",
  "BNP PARIBAS": "/img/banks/266.svg",
  "BANCO PROVINCIA DE TIERRA DEL FUEGO": "/img/banks/268.png",
  "BANCO DE LA REPUBLICA ORIENTAL DEL URUGU": "/img/banks/269.ico",
  "BANCO SAENZ S.A.": "/img/banks/277.png",
  "BANCO MERIDIAN S.A.": "/img/banks/281.png",
  "BANCO MACRO S.A.": "/img/banks/285.svg",
  "BANCO COMAFI SOCIEDAD ANONIMA": "/img/banks/299.svg",
  "BANCO DE INVERSION Y COMERCIO EXTERIOR S": "/img/banks/300.jpg",
  "BANCO PIANO S.A.": "/img/banks/301.svg",
  "BANCO JULIO SOCIEDAD ANONIMA": "/img/banks/305.jpg",
  "BANCO RIOJA SOCIEDAD ANONIMA UNIPERSONAL": "/img/banks/309.ico",
  "BANCO DEL SOL S.A.": "/img/banks/310.svg",
  "NUEVO BANCO DEL CHACO S. A.": "/img/banks/311.ico",
  "BANCO VOII S.A.": "/img/banks/312.png",
  "BANCO DE FORMOSA S.A.": "/img/banks/315.ico",
  "BANCO CMF S.A.": "/img/banks/319.png",
  "BANCO DE SANTIAGO DEL ESTERO S.A.": "/img/banks/321.png",
  "BANCO INDUSTRIAL S.A.": "/img/banks/322.png",
  "NUEVO BANCO DE SANTA FE SOCIEDAD ANONIMA": "/img/banks/330.svg",
  "BANCO CETELEM ARGENTINA S.A.": "/img/banks/331.png",
  "BANCO DE SERVICIOS FINANCIEROS CARREFOUR": "/img/banks/332.png",
  "BANCO DE SERVICIOS Y TRANSACCIONES SAU": "/img/banks/338.webp",
  "RCI BANQUE S.A.": "/img/banks/339.ico",
  "BACS BANCO DE CREDITO Y SECURITIZACION S": "/img/banks/340.png",
  "BANCO MASVENTAS S.A.": "/img/banks/341.ico",
  "UALA BANK S.A.U.": "/img/banks/384.svg",
  "NUEVO BANCO DE ENTRE RÍOS S.A.": "/img/banks/386.svg",
  "BANCO COLUMBIA S.A.": "/img/banks/389.svg",
  "BANCO BICA S.A.": "/img/banks/426.svg",
  "BANCO COINAG S.A.": "/img/banks/431.svg",
  "BANCO DE COMERCIO S.A.": "/img/banks/432.png",
  "BANCO SUCREDITO REGIONAL S.A.U.": "/img/banks/435.png",
  "COMPAÑIA FINANCIERA ARGENTINA S.A.": "/img/banks/44077.jpg",
  "VOLKSWAGEN FINANCIAL SERVICES COMPAÑIA F": "/img/banks/44088.svg",
  "FCA COMPAÑIA FINANCIERA S.A.": "/img/banks/44092.png",
  "GPAT COMPAÑIA FINANCIERA S.A.U.": "/img/banks/44093.svg",
  "MERCEDES-BENZ COMPAÑÍA FINANCIERA ARGENT": "/img/banks/44094.svg",
  "ROMBO COMPAÑÍA FINANCIERA S.A.": "/img/banks/unknown.svg",
  "JOHN DEERE CREDIT COMPAÑÍA FINANCIERA S.": "/img/banks/44096.svg",
  "PSA FINANCE ARGENTINA COMPAÑÍA FINANCIER": "/img/banks/44098.png",
  "TOYOTA COMPAÑÍA FINANCIERA DE ARGENTINA": "/img/banks/44099.svg",
  "BANCO DINO S.A.": "/img/banks/448.svg",
  "NARANJA DIGITAL COMPAÑÍA FINANCIERA S.A.": "/img/banks/45030.svg",
  "MONTEMAR COMPAÑIA FINANCIERA S.A.": "/img/banks/45056.svg",
  "REBA COMPAÑIA FINANCIERA S.A.": "/img/banks/45072.png",
  "NARANJA X": "/img/banks/453.svg",
  "CRÉDITO REGIONAL COMPAÑÍA FINANCIERA S.A": "/img/banks/65203.png",
};
